import type { Point } from '../SurfaceBase';

export const RESIZE_HANDLE_DEBUG_COLORS: { [key: number]: string } = {
  0: 'red',
  1: 'green',
  2: 'red',
  3: 'green',
};

export const OPPOSITE_INDEX: { [key: number]: number } = {
  0: 2,
  1: 3,
  2: 0,
  3: 1,
};

export const BBOX_COLOR = 'red';

export function getMidpoint(p1: Point, p2: Point): Point {
  const p: Point = {
    x: (p1.x + p2.x) / 2,
    y: (p1.y + p2.y) / 2,
  };

  return p;
}
